import { create } from "zustand";

export type MenuTab = "statistics" | "invite";

interface MenuTabState {
  activeTab: MenuTab;
  setActiveTab: (elem: MenuTab) => void;
}

export const useMenuTabStore = create<MenuTabState>()((set) => ({
  activeTab: "invite",
  setActiveTab: (elem) =>
    set(() => ({
      activeTab: elem,
    })),
}));
